const CFM_TITLE = 'cfmTitle';
const CFM_SUBTITLE = 'cfmSubtitle';

export {
  CFM_TITLE,
  CFM_SUBTITLE,
};
